import type { AxiosResponse } from 'axios';
import axios from 'axios';

import { apiConfig } from '@montugroup/circuit-shared/api/api.config';

import settings from '../constants/constants';

const API_URL = `${settings.url}/data`;
const CUSTOMER_PORTAL_XAPI_URL = `${apiConfig().baseApiUrl}/api/customer-portal/v1`;

type PrescriptionData = {
  createdDate: string;
  presciptionCode: string;
  productName: string;
  productId: number;
  thcStrength: string | null;
  cbdStrength: string | null;
  dosage: string | null;
  quantity: number;
  repeats: string;
  interval: number | null;
  expiryDate: string | null;
  status: string;
  inActive: boolean;
};

const getPatientPrescriptions = () => axios.get<PrescriptionData[]>(`${API_URL}/patient/prescription`);

export type IPatientOrderSummary = {
  hasOrders: boolean;
  openOrdersCount: number;
};

const getPatientOrderSummary = async () =>
  axios.get<AxiosResponse<IPatientOrderSummary>>(`${CUSTOMER_PORTAL_XAPI_URL}/patient-order-summary`);

export { getPatientOrderSummary, getPatientPrescriptions };
